import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/procedures_analytics_event.py
export const PROCEDURES_ANALYTICS_ACTIONS = {
  // PROCEDURE DESIGNER actions
  CREATED_PROCEDURE: {
    module: ANALYTICS_MODULE.PROCEDURES,
    action: 'created_procedure',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_PROCEDURE: {
    module: ANALYTICS_MODULE.PROCEDURES,
    action: 'updated_procedure',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ARCHIVED_PROCEDURE: {
    module: ANALYTICS_MODULE.PROCEDURES,
    action: 'archived_procedure',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UNARCHIVED_PROCEDURE: {
    module: ANALYTICS_MODULE.PROCEDURES,
    action: 'unarchived_procedure',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  TOGGLED_PROCEDURE_VIEW: {
    module: ANALYTICS_MODULE.PROCEDURES,
    action: 'toggled_procedure_view',
    actionCategory: ACTION_CATEGORY.READ,
  },
  REORDERED_PROCEDURE_METHODS: {
    module: ANALYTICS_MODULE.PROCEDURES,
    action: 'reordered_procedure_methods',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_PROCEDURE_METHOD: {
    module: ANALYTICS_MODULE.PROCEDURES,
    action: 'created_procedure_method',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_PROCEDURE_METHOD: {
    module: ANALYTICS_MODULE.PROCEDURES,
    action: 'updated_procedure_method',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  REMOVED_PROCEDURE_METHOD: {
    module: ANALYTICS_MODULE.PROCEDURES,
    action: 'removed_procedure_method',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_PROCEDURE_STEP: {
    module: ANALYTICS_MODULE.PROCEDURES,
    action: 'created_procedure_step',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_PROCEDURE_STEP: {
    module: ANALYTICS_MODULE.PROCEDURES,
    action: 'updated_procedure_step',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ENCOUNTERED_CONFIGURATION_VALIDATION_ERROR: {
    module: ANALYTICS_MODULE.PROCEDURES,
    action: 'encountered_configuration_validation_error',
    actionCategory: ACTION_CATEGORY.WRITE,
  },

  CREATED_PROCEDURE_PARAMETER: {
    module: ANALYTICS_MODULE.PROCEDURES,
    action: 'created_procedure_parameter',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_PROCEDURE_PARAMETER: {
    module: ANALYTICS_MODULE.PROCEDURES,
    action: 'updated_procedure_parameter',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DUPLICATED_PROCEDURE: {
    module: ANALYTICS_MODULE.PROCEDURES,
    action: 'duplicated_procedure',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  MOVED_PROCEDURE: {
    module: ANALYTICS_MODULE.PROCEDURES,
    action: 'moved_procedure',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  REORDERED_PROCEDURE_STEP: {
    module: ANALYTICS_MODULE.PROCEDURES,
    action: 'reordered_procedure_step',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  FILTERED_PROCEDURE_FLOWCHART_VIEW: {
    module: ANALYTICS_MODULE.PROCEDURES,
    action: 'filtered_procedure_flowchart_view',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SWITCHED_METHOD_CONFIGURATION: {
    module: ANALYTICS_MODULE.PROCEDURES,
    action: 'switched_method_configuration',
    actionCategory: ACTION_CATEGORY.READ,
  },
  VIEWED_PROCEDURE_VALIDATION_ERRORS_PANEL: {
    module: ANALYTICS_MODULE.PROCEDURES,
    action: 'viewed_procedure_validation_errors_panel',
    actionCategory: ACTION_CATEGORY.READ,
  },
  ADDED_ASSOCIATION_TO_PMEI: {
    module: ANALYTICS_MODULE.PROCEDURES,
    action: 'added_associations_to_pmei',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DELETED_ASSOCIATION_FROM_PMEI: {
    module: ANALYTICS_MODULE.PROCEDURES,
    action: 'deleted_associations_from_pmei',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
};
